import { render, staticRenderFns } from "./addBranch.vue?vue&type=template&id=6f697e16&"
import script from "./addBranch.vue?vue&type=script&lang=js&"
export * from "./addBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports